import React, { useEffect, useState } from 'react';
import useConnectionStatus from '../../telemetry/useConnectionStatus';

function formatAgo(ts) {
  if (!ts) return '—';
  var sec = Math.max(0, Math.floor((Date.now() - ts) / 1000));
  if (sec < 1) return 'just now';
  if (sec < 60) return sec + 's ago';
  return Math.floor(sec / 60) + 'm ago';
}

export default function LiveStatusIndicator(props) {
  var status = useConnectionStatus();
  var _tick = useState(0);
  var setTick = _tick[1];
  var pulseKey = status.pulseSeq;
  var minimized = !!props.minimized;

  useEffect(function () {
    var id = setInterval(function () {
      setTick(function (n) {
        return n + 1;
      });
    }, 1000);
    return function () {
      clearInterval(id);
    };
  }, []);

  var label = status.connected
    ? 'Connected'
    : status.connecting
      ? 'Connecting…'
      : 'Disconnected';

  var latencyLabel =
    status.connected && status.latency != null
      ? status.latency + ' ms'
      : '—';

  var title = minimized
    ? 'Expand live telemetry'
    : props.active
      ? 'Collapse telemetry'
      : 'Expand live telemetry';

  return (
    <button
      type="button"
      className={
        'telemetry-live' +
        (status.connected ? ' is-live' : ' is-offline') +
        (props.active ? ' is-open' : '') +
        (minimized ? ' is-minimized' : '')
      }
      onClick={props.onToggle}
      aria-expanded={!!props.active}
      aria-controls="telemetry-panel"
      aria-label={
        minimized
          ? 'Live telemetry, ' + label + '. Tap to expand.'
          : undefined
      }
      title={title}
    >
      <span
        key={minimized ? 'min' : pulseKey}
        className="telemetry-live__pulse"
        aria-hidden="true"
      />
      {!minimized ? (
        <span className="telemetry-live__body">
          <span className="telemetry-live__copy">
            <strong>LIVE TELEMETRY</strong>
            <span>{label}</span>
            <span>Latency {latencyLabel}</span>
            <span>Updated {formatAgo(status.lastUpdate)}</span>
          </span>
          <span className="telemetry-live__expand" aria-hidden="true">
            <span className="telemetry-live__expand-label">
              {props.active ? 'Collapse' : 'Click to expand'}
            </span>
            <span
              className={
                'telemetry-live__chevron' + (props.active ? ' is-open' : '')
              }
            >
              ▾
            </span>
          </span>
        </span>
      ) : null}
    </button>
  );
}
